import React, { Dispatch, SetStateAction } from "react"
import {
  CustomOperation,
  CustomState,
  Order,
  OrderCustomState,
  OrderHistoryLogEntry,
  OrderState
} from "lib/types/generated/graphql-types"
import {
  Container,
  InfoBox,
  Label,
  NoticeWrapper,
  StyledStatus,
  Wrapper
} from "./OrderHeader.styled"
import OrderCustomStates from "../OrderOverview/OrderCustomStates"
import dayjs from "dayjs"
import { useSelector } from "react-redux"
import { selectUserAttributes } from "lib/store/services/auth/selectors"
import PaymentStatus from "./PaymentStatus"
import OperationStatus from "./OperationStatus"
import Notice from "./Notice"
import { Deliveries } from "../../../classes/order/Deliveries"

type Props = {
  order: Order
  historyProps: {
    customStates: CustomState[]
    addCustomStateToHistory: (customStateId: string) => void
    setOrderHistoryList: Dispatch<SetStateAction<OrderHistoryLogEntry[]>>
    orderHistoryList: OrderHistoryLogEntry[]
    setCustomStateList: Dispatch<SetStateAction<OrderCustomState[]>>
    customStateList: OrderCustomState[]
    getCustomState: (id: string) => CustomState | undefined
  }
  loading: boolean
}

const OrderHeader = ({ order, historyProps, loading }: Props) => {
  const userAttributes = useSelector(selectUserAttributes)
  const deliveries = new Deliveries(order?.Deliveries)

  const {
    setOrderHistoryList,
    orderHistoryList,
    setCustomStateList,
    customStateList,
    getCustomState
  } = historyProps

  const isOrderCancelled = () => order?.status?.orderStates?.includes(OrderState.Cancelled)


  const removeCustomStateFromHistory = (id: string): void => {
    const entry: OrderHistoryLogEntry = {
      actor: { name: userAttributes.email, type: "USER" },
      operation: "CUSTOM_STATE",
      operationId: id,
      status: "NONE",
      timestamp: dayjs(),
      type: "REMOVE_CUSTOM_STATE"
    }
    setOrderHistoryList([...orderHistoryList, entry])
    setCustomStateList(customStateList.filter((state) => state.id !== id))
  }

  return (
    <Wrapper className={loading ? "blur" : ""}>
      <Container>
        {deliveries.completedDeliveries().length === 0 && <InfoBox>
          <Label>Order Status</Label>{" "}
          <StyledStatus status={isOrderCancelled() ? "Cancelled" : "Placed"} />
        </InfoBox> }
        {customStateList.length > 0 && (
          <InfoBox>
            <Label>
              Current State {customStateList.length > 1 && `(out of ${customStateList.length})`}
            </Label>
            <OrderCustomStates
              customStates={customStateList}
              getCustomState={getCustomState}
              orderId={order?.id}
              orderRef={order?.reference}
              removeCustomStateFromHistory={removeCustomStateFromHistory}
            />
          </InfoBox>
        )}
        <PaymentStatus payment={order?.Payment} />
        <OperationStatus
          operationType={CustomOperation.Compensation}
          states={order?.status?.orderStates}
        />
        <OperationStatus
          operationType={CustomOperation.Delivery}
          states={order?.status?.orderStates ?? []}
        />
        <OperationStatus
          operationType={CustomOperation.Refund}
          states={order?.status?.orderStates ?? []}
        />
        <OperationStatus
          operationType={CustomOperation.Release}
          states={order?.status?.orderStates ?? []}
        />
      </Container>
      <NoticeWrapper>
        <Notice order={order} />
      </NoticeWrapper>
    </Wrapper>
  )
}

export default OrderHeader
